/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTeacherRequest
 */
export interface UpdateTeacherRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTeacherRequest
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    lastName: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTeacherRequest
     */
    payRate: number;
    /**
     * 
     * @type {PaymentType}
     * @memberof UpdateTeacherRequest
     */
    paymentType: PaymentType;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    preferredName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    biography: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    cellPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    homePhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    payrollId: string | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateTeacherRequest
     */
    dateOfBirth: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateTeacherRequest
     */
    startDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateTeacherRequest
     */
    endDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    state: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    zip: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherRequest
     */
    country: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTeacherRequest
     */
    isInContactUsMailingList: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTeacherRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof UpdateTeacherRequest
     */
    workLocationIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof UpdateTeacherRequest
     */
    classIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTeacherRequest
     */
    isFeatured?: boolean | null;
}



/**
 * Check if a given object implements the UpdateTeacherRequest interface.
 */
export function instanceOfUpdateTeacherRequest(value: object): value is UpdateTeacherRequest {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('paymentType' in value) || value['paymentType'] === undefined) return false;
    if (!('preferredName' in value) || value['preferredName'] === undefined) return false;
    if (!('biography' in value) || value['biography'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('homePhone' in value) || value['homePhone'] === undefined) return false;
    if (!('payrollId' in value) || value['payrollId'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('isInContactUsMailingList' in value) || value['isInContactUsMailingList'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('workLocationIds' in value) || value['workLocationIds'] === undefined) return false;
    if (!('classIds' in value) || value['classIds'] === undefined) return false;
    return true;
}

export function UpdateTeacherRequestFromJSON(json: any): UpdateTeacherRequest {
    return UpdateTeacherRequestFromJSONTyped(json, false);
}

export function UpdateTeacherRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeacherRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'payRate': json['payRate'],
        'paymentType': PaymentTypeFromJSON(json['paymentType']),
        'preferredName': json['preferredName'],
        'biography': json['biography'],
        'cellPhone': json['cellPhone'],
        'homePhone': json['homePhone'],
        'payrollId': json['payrollId'],
        'dateOfBirth': json['dateOfBirth'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'country': json['country'],
        'isInContactUsMailingList': json['isInContactUsMailingList'],
        'isActive': json['isActive'],
        'workLocationIds': ((json['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'classIds': ((json['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
    };
}

export function UpdateTeacherRequestToJSON(json: any): UpdateTeacherRequest {
    return UpdateTeacherRequestToJSONTyped(json, false);
}

export function UpdateTeacherRequestToJSONTyped(value?: UpdateTeacherRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'payRate': value['payRate'],
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'preferredName': value['preferredName'],
        'biography': value['biography'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'payrollId': value['payrollId'],
        'dateOfBirth': value['dateOfBirth'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
        'isInContactUsMailingList': value['isInContactUsMailingList'],
        'isActive': value['isActive'],
        'workLocationIds': ((value['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'classIds': ((value['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'isFeatured': value['isFeatured'],
    };
}

